var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"verifystyle"},[_c('spinner',{attrs:{"status":_vm.component_loading}})],1)]),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }